// angular
import { AfterContentInit, Component, inject, input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
// types & env
import { LocPosition } from '@app/+about/shared/types/lock-position.type';
import { environment } from '@environments/environment';

@Component({
  selector: 'pwj-map-box',
  standalone: true,
  imports: [NgxSkeletonLoaderModule],
  templateUrl: './map-box.component.html',
  styleUrl: './map-box.component.scss',
})
export class MapBoxComponent implements AfterContentInit {
  public center!: LocPosition;
  public mapApiKey: string = environment.mapApiKey;
  public mapUrl!: SafeResourceUrl;
  public isLoadingMap: boolean = true;

  // inputs
  location = input<LocPosition>();

  // dependencies
  private readonly _sanitizer = inject(DomSanitizer);
  constructor() {}

  ngAfterContentInit(): void {
    this.center = {
      lat: Number(this.location()?.lat),
      lng: Number(this.location()?.lng),
    };

    this.getMapUrl();
  }

  public getMapUrl() {
    const latitude = this.center.lat;
    const longitude = this.center.lng;
    const url = `https://www.google.com/maps/embed/v1/place?key=${this.mapApiKey}&q=${latitude},${longitude}`;
    this.mapUrl = this._sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public onLoadFinished() {
    this.isLoadingMap = false;
  }
}
